import { useState, useRef, useEffect } from "react";
// models
import {  ExperienciaModel, initialValuesExperienciasmodel, AreasModel } from "../models/JuradosModel/agregarExpericiencia.model";
// api services
import JuradosService from "../api/Jurados/api-jurados";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import { juradoEditar, juradoAtras, menuJuradoAction } from '../redux/actions/juradosAction';
import { openNotification } from "../utils/saveFile";
import DocumentosService from "../api/Documentos/api-documentos";
import { useNavigate, useParams } from "react-router";


export const useAgregarExperienciaJurado = () => {
  const [experiencia, setExperiencia] = useState<ExperienciaModel>(initialValuesExperienciasmodel);
  const [experiencias, setExperiencias] = useState<Array<ExperienciaModel>>([]);
  const [modaleditar, setModaleditar] = useState<boolean>(false);
  const [modalVisualizar, setModalVisualizar] = useState<boolean>(false);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [nombreConvocatoria, setNombreConvocatoria] = useState<string>("");
  const [indexExperiencia, setIndexExperiencia] = useState<number>(0);
  const [areas, setAreas] = useState<Array<AreasModel>>([]);
  // ref
  const fileInputRef = useRef<any>();
  const { menuJurado } = useSelector((state: RootState) => state.jurado);
  const idJurado =  localStorage.getItem('idJurado')
  const dispatch = useDispatch()

  const { estadoFormulario } = useParams();

  const navigate = useNavigate();
  // functions
  useEffect(() => {
    cargarAreas();
    cargarExperiencias();
  }, [])

  const prevScreen = () => {
    dispatch(juradoAtras(true));
    return navigate("/usuario/agregarExperienciaProfesionalJurado")
  }

  const cargarExperiencias = async() => {
    const { data } = await JuradosService.obtenerExperiencias(idJurado)
    console.log(data, 'experiencias')
    return setExperiencias(data)
  }

  const agregarFila = () => {
    if (experiencia.documento === "") {
      return openNotification({titulo: "Error", descripcion: "Falta adjuntar archivo", placement: "bottomRight"});
    }

    if(Array.isArray(experiencias)) {
      setExperiencias([...experiencias, experiencia]);
    }else {
      setExperiencias([experiencia]);
    }



    return setExperiencia(initialValuesExperienciasmodel);
  };
  const limpiarCampos = () => {
    return setExperiencia(initialValuesExperienciasmodel);
  };

  const guardarCamposModal = () => {
    let infoupdate = [...experiencias];
    infoupdate[indexExperiencia] = experiencia;
    setExperiencias(infoupdate);
    setExperiencia(initialValuesExperienciasmodel);
    return setModaleditar(false);
  };

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type !== "application/pdf" ) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }

      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      setExperiencia({ ...experiencia, documento: data.data });
     
    }
  };

  

  const eliminarFila = (indexexp: number) => {
    console.log(indexexp);
    let infoupdate = [...experiencias];
    infoupdate = infoupdate.filter((data: any, index:number) => index !== indexexp);
    setExperiencias(infoupdate);
    return setModaleliminar(false);
  };
  
  const cargarAreas = async() => {
    const data = await JuradosService.getAreas();
    setAreas(data)
  }

  const guardarExperienciaJurado = async() => {
    

    try{
      await JuradosService.guardarExperienciaJurado(idJurado, experiencias)

      if(estadoFormulario != '' && estadoFormulario != undefined){
        dispatch(juradoEditar(false))
        return navigate('/usuario/estadosFormulario')
      }

      if(menuJurado) {
        dispatch(menuJuradoAction(false));
        return navigate('/usuario/MenuJurado')
      }

      return navigate('/usuario/Reconocimientos')
      
    }catch (error){
      console.log(error)
    }
    
  }

  return {
    experiencia,
    setExperiencia,
    experiencias,
    setExperiencias,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    indexExperiencia,
    setIndexExperiencia,
    fileInputRef,
    agregarFila,
    limpiarCampos,
    guardarCamposModal,
    guardarArchivo,
    eliminarFila,
    nombreConvocatoria,
    setNombreConvocatoria,
    areas,
    setAreas,
    guardarExperienciaJurado,
    modalVisualizar,
    setModalVisualizar,
    prevScreen,
  };
};


